import makeStyles from '@mui/styles/makeStyles';

export const useStyle = makeStyles((theme) => ({
  videoPlayer: {
    display: 'inline-block',
    width: '100%',
    overflow: 'hidden',
    borderStyle: 'solid',
    borderWidth: '1px 5px 5px 1px',
    borderRadius: '1.5rem',
    [theme.breakpoints.down('md')]: {
      marginTop: '-5rem'
    }
  },
  videoContainer: {
    display: 'inline-block',
    width: '100%',
    overflow: 'hidden'
  }
}));
